import React from "react";

export default function Address() {
  return (
    <section className="address">
      <div className="address__container">
        <div className="address__box box_one">
          <h2 className="address__title">
            <a href="#record" className="address__record">
              Запись на прием →
            </a>
          </h2>
          <p className="address__text">
            Оставьте заявку, мы перезвоним в течение рабочего дня и поможем
            выбрать удобное время для записи
          </p>
        </div>
        <div className="address__box box_two">
          <h2 className="address__title">Адрес института</h2>
          <p className="address__text">г. Екатеринбург, ул. Щербакова, 8</p>
        </div>
        <div className="address__box box_three">
          <h2 className="address__title">Время работы института</h2>
          <p className="address__text">
            Пн-Пт — 09:00 - 18:00 <br></br>Сб — 09:00 - 14:00
          </p>
        </div>
      </div>
    </section>
  );
}
